import React, { useState } from 'react';

import { NavLink } from 'react-router-dom';

import {
  AppBar,
  List,
  ListItem,
  ListItemButton,
  Toolbar,
  Typography,
  IconButton,
  Drawer,
} from '@mui/material';

import MenuIcon from '@mui/icons-material/Menu';

import { COLORS } from '../../../Constant/COLORS';

import { TypoPoppins } from '../../../Components/Typo';

const MobileNavigationLayout = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const navLinks = [
    { text: 'My Details', to: 'my-details' },
    { text: 'Job Requests', to: 'job-requests' },
    { text: 'Job Informations', to: 'job-informations' },
    { text: 'Review Manage', to: 'review-manage' },
  ];

  return (
    <>
      <AppBar position='static' color='blue' elevation={0}>
        <Toolbar>
          <TypoPoppins variant='h4' fontWeight={600} my={1.5} color='#fff'>
            Profile
          </TypoPoppins>
          <IconButton sx={{ ml: 'auto' }} onClick={() => setIsDrawerOpen(true)}>
            <MenuIcon htmlColor='white' />
          </IconButton>
        </Toolbar>
      </AppBar>

      <Drawer
        open={isDrawerOpen}
        PaperProps={{ sx: { p: 3, pl: 5 } }}
        onClose={() => setIsDrawerOpen(false)}
      >
        <List disablePadding sx={{ whiteSpace: 'nowrap', mt: 3, ml: -2 }}>
          {navLinks.map(({ text, to }) => (
            // eslint-disable-next-line react/jsx-key
            <ListItem disableGutters disablePadding sx={{ mb: 1 }} key={to}>
              <ListItemButton
                component={NavLink}
                to={`../${to}`}
                style={({ isActive }) =>
                  isActive
                    ? { backgroundColor: COLORS.white3, borderRadius: 4 }
                    : undefined
                }
              >
                <Typography
                  variant='body1'
                  fontWeight={600}
                  color={COLORS.blue}
                  sx={{ pointerEvents: 'none' }}
                >
                  {text}
                </Typography>
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Drawer>
    </>
  );
};

export default MobileNavigationLayout;
